import "./Switch.css"

export default function Switch (props) {
  const onStyle = props.value ? " switch-on" : ''
  return (
    <span className="switch-body" onClick={props.onClick}>
      <span className={"switch-dot"+onStyle}/>
    </span>
  )
}
